module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARBAMAAADJQ1rJAAAAFVBMVEUAAAA8gPzzmD47gfz1mj/ylz07gPt0yILXAAAABXRSTlMA4+NJSYO+i+YAAAA3SURBVAjXYwADZrFEAwiLMS1NAMJiS0tLwGQhZIE6nEJDQ4McQFzVUCBQALFCQSCAYhbCPJgdAKZtGrWUG7PEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/dianzhui.png
// module id = FVDe
// module chunks = 36